/*
 * Hippo Floors — Header custom JS
 * - Inline search bar on desktop (replaces search icon)
 * - Mobile search bar + phone icon are server-rendered (no JS needed)
 * - Predictive search on both desktop + mobile search bars
 */
(function() {
  'use strict';

  var SEARCH_SVG =
    '<svg width="22" height="22" viewBox="0 0 21 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M19.3468 15.9327L15.7608 12.3468C15.6679 12.2539 15.5577 12.1802 15.4364 12.1299C15.3151 12.0796 15.1851 12.0537 15.0538 12.0537C14.9224 12.0537 14.7924 12.0796 14.6711 12.1299C14.5498 12.1802 14.4396 12.2539 14.3468 12.3468L14.0538 12.6397L12.6522 11.2381C13.717 9.81561 14.2035 8.04255 14.0136 6.27585C13.8236 4.50914 12.9715 2.87999 11.6286 1.71636C10.2857 0.552743 8.55188 -0.0589335 6.77613 0.00448038C5.00037 0.0678943 3.31458 0.80169 2.05814 2.05814C0.80169 3.31458 0.0678943 5.00037 0.00448038 6.77613C-0.0589335 8.55188 0.552743 10.2857 1.71636 11.6286C2.87999 12.9715 4.50914 13.8236 6.27585 14.0136C8.04255 14.2035 9.81561 13.717 11.2381 12.6522L12.6397 14.0538L12.3468 14.3468C12.2539 14.4396 12.1802 14.5498 12.1299 14.6711C12.0796 14.7924 12.0537 14.9224 12.0537 15.0538C12.0537 15.1851 12.0796 15.3151 12.1299 15.4364C12.1802 15.5577 12.2539 15.6679 12.3468 15.7608L15.9327 19.3468C16.3854 19.7995 16.9994 20.0538 17.6397 20.0538C18.28 20.0538 18.894 19.7995 19.3468 19.3468C19.7995 18.894 20.0538 18.28 20.0538 17.6397C20.0538 16.9994 19.7995 16.3854 19.3468 15.9327Z"/>' +
    '</svg>';

  /* ─── Shared predictive-search state ─── */
  var abortCtrl = null;
  var debounceTimer = null;
  var cachedResults = null;
  var cachedQuery = '';

  function init() {
    transformSearch();
    initTypewriter();
    initMobilePredictiveSearch();
    window.addEventListener('resize', debounce(handleResize, 200));
    document.addEventListener('shopify:section:load', function() {
      transformSearch();
      initMobilePredictiveSearch();
    });
  }

  /* ─── Typewriter placeholder animation ─── */
  function startTypewriter(input) {
    if (!input || input.dataset.hfTwInit) return;
    input.dataset.hfTwInit = '1';

    var phrases = ['What are you looking for?', 'Coastal Blackbutt SPC'];
    var phraseIdx = 0;
    var charIdx = 0;
    var deleting = false;
    var timer = null;

    input.placeholder = '';

    function tick() {
      var current = phrases[phraseIdx];

      if (!deleting) {
        charIdx++;
        input.placeholder = current.substring(0, charIdx);
        if (charIdx === current.length) {
          timer = setTimeout(function() { deleting = true; tick(); }, 2000);
          return;
        }
        timer = setTimeout(tick, 70);
      } else {
        charIdx--;
        input.placeholder = current.substring(0, charIdx);
        if (charIdx === 0) {
          deleting = false;
          phraseIdx = (phraseIdx + 1) % phrases.length;
          timer = setTimeout(tick, 400);
          return;
        }
        timer = setTimeout(tick, 35);
      }
    }

    tick();

    // Stop animation when user focuses the input
    input.addEventListener('focus', function() {
      clearTimeout(timer);
      input.placeholder = '';
    });

    // Restart when user leaves the input empty
    input.addEventListener('blur', function() {
      if (!input.value.trim()) {
        phraseIdx = 0;
        charIdx = 0;
        deleting = false;
        tick();
      }
    });
  }

  function initTypewriter() {
    // Mobile typewriter
    var mobileInput = document.querySelector('[data-hf-typewriter]');
    if (mobileInput && window.innerWidth < 750) {
      startTypewriter(mobileInput);
    }
    // Desktop typewriter
    var desktopInput = document.querySelector('.hf-search-inline input');
    if (desktopInput && window.innerWidth >= 990) {
      startTypewriter(desktopInput);
    }
  }

  /* ─── Inline search bar (desktop only) ─── */
  function transformSearch() {
    if (window.innerWidth < 990) return;
    if (document.querySelector('.hf-search-inline')) return;

    var rightCol = document.querySelector('header-component .header__column--right');
    if (!rightCol) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'hf-search-inline';
    wrapper.innerHTML =
      '<input type="text" placeholder="What are you looking for?" aria-label="Search" autocomplete="off">' +
      '<button type="button" class="hf-search-inline__btn" aria-label="Search">' +
        SEARCH_SVG +
      '</button>';

    var input = wrapper.querySelector('input');
    var btn = wrapper.querySelector('.hf-search-inline__btn');

    btn.addEventListener('click', function() {
      var val = input.value.trim();
      if (val) {
        window.location.href = '/search?q=' + encodeURIComponent(val);
      }
    });

    var headerActions = rightCol.querySelector('header-actions');
    if (headerActions) {
      rightCol.insertBefore(wrapper, headerActions);
    } else {
      rightCol.insertBefore(wrapper, rightCol.firstChild);
    }

    // Attach predictive search to desktop input
    var dropdown = createDropdown(wrapper);
    attachPredictiveSearch(input, dropdown, false);
  }

  /* ─── Mobile predictive search ─── */
  function initMobilePredictiveSearch() {
    var mobileSearch = document.querySelector('.hf-mobile-search');
    if (!mobileSearch || mobileSearch.dataset.hfPsInit) return;
    mobileSearch.dataset.hfPsInit = '1';

    var input = mobileSearch.querySelector('input');
    if (!input) return;

    var dropdown = createDropdown(mobileSearch);
    attachPredictiveSearch(input, dropdown, true);
  }

  /* ─── Predictive search: create dropdown ─── */
  function createDropdown(parentEl) {
    var dd = document.createElement('div');
    dd.className = 'hf-ps-dropdown';
    dd.setAttribute('role', 'listbox');
    dd.setAttribute('aria-hidden', 'true');
    parentEl.appendChild(dd);
    return dd;
  }

  /* ─── Predictive search: fetch suggestions ─── */
  function fetchPredictions(query, dropdown) {
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,page&resources[limit]=5';

    fetch(url, { signal: abortCtrl.signal })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var resources = data.resources && data.resources.results ? data.resources.results : {};
        cachedResults = resources;
        cachedQuery = query;
        renderDropdown(resources, query, dropdown);
      })
      .catch(function(err) {
        if (err.name !== 'AbortError') {
          console.error('Predictive search error:', err);
        }
      });
  }

  /* ─── Predictive search: render dropdown ─── */
  function renderDropdown(results, query, dropdown) {
    var html = '';
    var products = results.products || [];
    var collections = results.collections || [];
    var pages = results.pages || [];

    if (!products.length && !collections.length && !pages.length) {
      html = '<div class="hf-ps-dropdown__empty">No results for &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
      dropdown.innerHTML = html;
      showDropdown(dropdown);
      return;
    }

    if (products.length) {
      html += '<div class="hf-ps-dropdown__group">';
      html += '<div class="hf-ps-dropdown__heading">Products</div>';
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var imgSrc = p.image ? p.image.replace(/(\.\w+)(\?|$)/, '_100x100$1$2') : '';
        // price removed
        html += '<a href="' + p.url + '" class="hf-ps-dropdown__item" role="option">';
        if (imgSrc) {
          html += '<img class="hf-ps-dropdown__item-img" src="' + imgSrc + '" alt="" loading="lazy">';
        }
        html += '<div class="hf-ps-dropdown__item-info">';
        html += '<span class="hf-ps-dropdown__item-title">' + escapeHtml(p.title) + '</span>';
        // price line removed
        html += '</div></a>';
      }
      html += '</div>';
    }

    if (collections.length) {
      html += '<div class="hf-ps-dropdown__group">';
      html += '<div class="hf-ps-dropdown__heading">Collections</div>';
      for (var c = 0; c < collections.length; c++) {
        html += '<a href="' + collections[c].url + '" class="hf-ps-dropdown__item" role="option">';
        html += '<span class="hf-ps-dropdown__item-title">' + escapeHtml(collections[c].title) + '</span>';
        html += '</a>';
      }
      html += '</div>';
    }

    if (pages.length) {
      html += '<div class="hf-ps-dropdown__group">';
      html += '<div class="hf-ps-dropdown__heading">Pages</div>';
      for (var pg = 0; pg < pages.length; pg++) {
        html += '<a href="' + pages[pg].url + '" class="hf-ps-dropdown__item" role="option">';
        html += '<span class="hf-ps-dropdown__item-title">' + escapeHtml(pages[pg].title) + '</span>';
        html += '</a>';
      }
      html += '</div>';
    }

    html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="hf-ps-dropdown__footer" role="option">View all results</a>';

    dropdown.innerHTML = html;
    showDropdown(dropdown);
  }

  /* ─── Predictive search: wire up input ─── */
  function attachPredictiveSearch(inputEl, dropdown, isForm) {
    // Debounced input handler
    inputEl.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var val = inputEl.value.trim();
      if (val.length < 2) {
        hideDropdown(dropdown);
        cachedResults = null;
        cachedQuery = '';
        return;
      }
      debounceTimer = setTimeout(function() {
        fetchPredictions(val, dropdown);
      }, 300);
    });

    // Keyboard navigation
    inputEl.addEventListener('keydown', function(e) {
      var items = dropdown.querySelectorAll('[role="option"]');
      if (!items.length && e.key !== 'Escape') {
        // No dropdown items — let Enter do default search
        if (e.key === 'Enter' && !isForm && inputEl.value.trim()) {
          window.location.href = '/search?q=' + encodeURIComponent(inputEl.value.trim());
          e.preventDefault();
        }
        return;
      }

      var current = dropdown.querySelector('[aria-selected="true"]');
      var idx = -1;
      if (current) {
        for (var i = 0; i < items.length; i++) {
          if (items[i] === current) { idx = i; break; }
        }
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (current) current.setAttribute('aria-selected', 'false');
        idx = (idx + 1) % items.length;
        items[idx].setAttribute('aria-selected', 'true');
        items[idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (current) current.setAttribute('aria-selected', 'false');
        idx = idx <= 0 ? items.length - 1 : idx - 1;
        items[idx].setAttribute('aria-selected', 'true');
        items[idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        if (current && current.href) {
          e.preventDefault();
          window.location.href = current.href;
        } else if (!isForm && inputEl.value.trim()) {
          // Desktop: no form, navigate manually
          e.preventDefault();
          window.location.href = '/search?q=' + encodeURIComponent(inputEl.value.trim());
        }
        // isForm + no selection: let the form submit naturally
      } else if (e.key === 'Escape') {
        hideDropdown(dropdown);
        inputEl.blur();
      }
    });

    // Re-show cached results on focus
    inputEl.addEventListener('focus', function() {
      if (cachedResults && inputEl.value.trim().length >= 2) {
        renderDropdown(cachedResults, cachedQuery, dropdown);
      }
    });

    // Close dropdown on click outside
    document.addEventListener('click', function(e) {
      if (!inputEl.contains(e.target) && !dropdown.contains(e.target)) {
        hideDropdown(dropdown);
      }
    });
  }

  /* ─── Helpers ─── */
  function showDropdown(dd) {
    dd.setAttribute('aria-hidden', 'false');
  }

  function hideDropdown(dd) {
    dd.setAttribute('aria-hidden', 'true');
    // Clear any active selection
    var sel = dd.querySelector('[aria-selected="true"]');
    if (sel) sel.setAttribute('aria-selected', 'false');
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseFloat(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function handleResize() {
    var inline = document.querySelector('.hf-search-inline');

    if (window.innerWidth < 990) {
      if (inline) inline.style.display = 'none';
    } else {
      if (inline) {
        inline.style.display = 'flex';
      } else {
        transformSearch();
      }
    }
  }

  function debounce(fn, delay) {
    var timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
